import { RegionShared } from "@1games-ru/region-shared";
import { useEffect, useState } from "react";
import { callServer } from "@/core/helpers/callEvent.ts";
import useErrorTranslation from "@/core/helpers/useErrorTranslation";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import { PIN_LENGTH } from "@/domains/auth/constants/other.ts";
import toast from "@/domains/toasts/helpers/toast.ts";
import AuthUpdatePin from "@/domains/auth/components/update/AuthUpdatePin.tsx";

export default function AuthUpdatePinContainer() {
  const tError = useErrorTranslation();
  const [pending, setPending] = useState<boolean>(false);
  const [pin, setPin] = useState<string>("");
  const [pinRepeat, setPinRepeat] = useState<string>("");
  const [error, setError] = useState<string | undefined>();

  const onSubmit = async (newPin) => {
    if (pending) return;
    setPending(true);
    const response = await callServer(RegionShared.Backend.Events.Auth.RecoveryNewPassword, {
      pin: newPin,
    });
    if (response instanceof RpcMpProviderSuccessResponse) {
      toast.success("ПИН-код успешно изменён");
    } else {
      const { message } = response as { message: string };
      setError(tError(message));
    }

    setPending(false);
  };

  useEffect(() => {
    if (pin.length === PIN_LENGTH && pin === pinRepeat && !pending) {
      onSubmit(pinRepeat);
    }
  }, [pin, pinRepeat, pending]);

  return (
    <AuthUpdatePin
      title="Установка нового пин-кода"
      pin={pin}
      onPinChange={setPin}
      pinRepeat={pinRepeat}
      onPinRepeatChange={setPinRepeat}
      onSubmit={onSubmit}
      pending={pending}
      error={error}
    />
  );
}
